import { ApplicationView } from "@mixitone/mvc";
import { twMerge } from "tailwind-merge";
import SectionTab from "./SectionTab";

type SectionTabsItem = {
  id: string;
  label: string;
};

type SectionTabsProps = {
  tabs: SectionTabsItem[];
  activeTabId: string;
  onChange: (tabId: string) => void;
  /** Merged onto the tab bar wrapper (e.g. `-mx-6 px-6` to bleed in a padded modal). */
  className?: string;
};

const SectionTabs = (props: SectionTabsProps) => {
  const { tabs, activeTabId, onChange, className } = props;

  return (
    <div className={twMerge("border-b border-gray-200 px-4 pt-1", className)}>
      <div className="flex flex-wrap gap-6" role="tablist" aria-label="Sections">
        {tabs.map((tab) => (
          <SectionTab
            key={tab.id}
            id={tab.id}
            label={tab.label}
            active={tab.id === activeTabId}
            onSelect={onChange}
          />
        ))}
      </div>
    </div>
  );
};

export type { SectionTabsItem, SectionTabsProps };
export default ApplicationView(SectionTabs);
